import { attr, Model } from 'redux-orm';
import { IORMModels, ISession } from 'src/Config/ConfigureOrm';
import { AppAction } from 'src';
import { IActivityThemeModel } from '../ActivityTheme/ActivityTheme';
import { IActivityCategoryModel } from '../ActivityCategory/ActivityCategory';
import Activity, { IActivityModel } from '../Activity/Activity';
import { SEARCH } from './Search.Actions';
import { ActivitySearchHelper } from 'src/helpers/SearchHelper';
import { ActivityCategorySelector } from '../ActivityCategory/ActivityCategory.Selector';
import { ActivitySelector } from '../Activity/Activity.Selector';
import { IUserColumns } from '../User/User';



export interface ISearchQueryObject{
  
    searchQuery: string,
    selectedTheme: string | null,
    searchScope: string
  }

export interface ISearchResult{
    ActivityThemes: IActivityThemeModel[];
    ActivityCategories: IActivityCategoryModel[];
    Activities: IActivityModel[];
}


export interface ISearch{
    id: number;
    Query: ISearchQueryObject;
    Result: ISearchResult;
}


 

export default class Search extends Model<ISearch> implements ISearch{
    public static modelName = 'Search';

    public static fields = {
        id: attr({}),
    }

    public static reducer(action: AppAction<any>, search: typeof Model, session: ISession<IORMModels>){
        switch(action.type){            
            case SEARCH:
            let activities : IActivityModel[] ; 
            const categories : IActivityCategoryModel[] = [];
            let themes: IActivityThemeModel[];
            const cats: IActivityCategoryModel[] = session.ActivityCategory.all().toModelArray(); 
            const user: IUserColumns = session.User.withId("0");
            const activityThemes: IActivityThemeModel[] = session.ActivityTheme.all().toModelArray();
            const onlyRelevant = action.payload.searchScope.toString() === "relevant" ? true : false;
            const activityCategory :IActivityCategoryModel[]= session.ActivityCategory.all().toModelArray();          
            activityCategory.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));;
            themes =  action.payload.selectedTheme ? activityThemes.filter(t => t.themeId.toString() === action.payload.selectedTheme): activityThemes 
            activities = session.Activity.all().toModelArray();
            if(onlyRelevant ){
                const userInterests = user.portalDetails.topicInterests;
                
                if(userInterests !== undefined){
                    if(userInterests.length>0){
                        themes.forEach( t =>
                        categories.push(...cats.filter(c => c.themeId.toString() === t.themeId.toString() && userInterests.indexOf(c.categoryId.toString()) !== -1 )))                                               
                        const actsFromCats :any[] = []
                        categories.forEach(cat => actsFromCats.push( ...session.ActivityCategory.withId(cat.categoryId.toString()).activitycategoryactivitiesSet.all().toRefArray() ))                        
                        activities = [];
                        actsFromCats.forEach(a => activities.push(a.toActivityId))                        
                    }
                }
            }else{
                themes.forEach( t =>
                categories.push(...cats.filter(c => c.themeId.toString() === t.themeId.toString()))        
                )                
            }
            let act: IActivityModel[] = []
            const fiuNo = action.payload.searchQuery.split("-").join("")
            
            if(!isNaN(fiuNo) && fiuNo.length === 10){
                
                activities.forEach(a => {if(a.fiuNo.toString() === fiuNo.toString()){ act.push(a)}})   
                
            }else{
            act= ActivitySearchHelper.ActivitySearch(action.payload.searchQuery, activities)
            }
            const CatMatch = session.ActivityCategory.all().toRefArray().filter(c => c.name.toLowerCase() === action.payload.searchQuery.toLowerCase())
            if(CatMatch.length > 0){
                const catActivityies :any[] = session.ActivityCategory.withId(CatMatch[0].categoryId.toString()).activitycategoryactivitiesSet.toRefArray()
                
                if(catActivityies !== undefined){
                    catActivityies.forEach(ca => {
                        if(act.findIndex(a => a.detailKursusId === ca.toActivityId.detailKursusId) === -1){
                            act.push(ca.toActivityId)
                        }
                    })
                }
            }            
            search.upsert<ISearch>(
                {
                    id:0,
                    Result: 
                    {
                        Activities: act, 
                        ActivityCategories: categories,
                        ActivityThemes: themes
                    },
                    Query: action.payload})
            
            break;
        }
    }
    public id: number;
    public Result: ISearchResult; 
    public Query: ISearchQueryObject; 


    

}
    


// WEBPACK FOOTER //
// ./src/Entities/Search/Search.ts